module.exports = __webpack_public_path__ + "assets/img/121304.1f040a47.svg";